/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const USE_FILE_STORAGE_STRINGS = {
  changedPermissionsToXFilesToastMsg: 'Changed permissions to {{count}} file(s)',
  deletedXElementsToastMsg: 'Deleted {{count}} element(s)',
  deletingFilesInProgress: 'Deleting files in progress...',
  downloadedElementToastMsg: 'Download started...',
  errorDeletingXElementsToastMsg: 'Error deleting {{count}} element(s)',
  errorDownloadingElementToastMsg: 'Error downloading item ',
  errorOccurred: 'An error occurred!',
  errorUploadingXFilesToastMsg: 'Error uploading {{count}} file(s)',
  extractingArchiveInProgress: 'Extracting archive in progress...',
  extractingArchiveSuccess: 'Extracting archive successful',
  fileUploadCompleteToastMsg: 'File upload complete',
  fileUploadErrorToastMsg: 'Error uploading file(s)',
  folderCreateSuccessToastMsg: 'Folder created!',
  uploadedXFilesToastMsg: 'Uploaded {{count}} file(s)',
} as const;
